import Vue from 'vue';
import Vuex from 'vuex';
import { CitationState } from './modules/citation/citation.types';
import citation from './modules/citation/citation.module';
import account from './modules/account/account.module';
import websocket from './modules/websocket/websocket.module'
import study from './modules/study/study.module'
import screening from './modules/screening/screening.module'
import duplicateCitation from './modules/duplicate-citation/duplicate-citation.module';
import excludedReasons from './modules/excluded-reason/excluded-reason.module';
import { badResponseHandlerPlugin } from './plugins/bad-response-handler.plugin';
import { AccountState } from './modules/account/account.types';
import { WebSocketState } from '@/store/modules/websocket/websocket.types';
import { StudyState } from './modules/study/study.types';
import { ScreeningState } from './modules/screening/screening.types';
import { DuplicateCitationState } from './modules/duplicate-citation/duplicate-citation.types';
import { ExcludedReasonState } from './modules/excluded-reason/excluded-reason.types';

Vue.use(Vuex);

export interface RootState {
    citation: CitationState;
    account: AccountState;
    websocket: WebSocketState;
    study: StudyState;
    screening: ScreeningState;
    duplicateCitation: DuplicateCitationState;
    excludedReasons: ExcludedReasonState;
}

export default new Vuex.Store<RootState>({
    strict: process.env.VUE_APP_ENV !== 'production',
    modules: {
        citation,
        account,
        websocket,
        study,
        screening,
        duplicateCitation,
        excludedReasons
    },
    plugins: [badResponseHandlerPlugin]
});
